import { styled } from '@mui/material';

export const StyledOption = styled('div')`
    line-height: 28px;
    padding: 4px 10px;
    color: ${props =>
        props.theme.palette.mode === 'dark' ? 'white' : '#121212'};
`;
